import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';

export const getBaseUrl = () => document.getElementsByTagName('base')[0].href + 'api';

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

config({ licenseKey });

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
